import { createDateFromYYYYMM } from "@icarius-utils/date";

export const timeUtils = {
    timeToDecimal: (time) => {
        if (!time) return null;
        const [hours, minutes] = time.split(':').map(Number);
        const dec = parseInt((minutes / 6) * 10, 10);
        return parseFloat(parseInt(hours, 10) + '.' + (dec < 10 ? '0' : '') + dec);
    },

    validateTimeFormat: (value) => {
        if (!value) return true;
        return /^(\d|0\d|1\d|2[0-3]):[0-5]\d$/.test(value);
    },

    isValidPeriod: (startDate, endDate) => {
        if (!startDate || !endDate) return true;
        const start = createDateFromYYYYMM(startDate);
        const end = createDateFromYYYYMM(endDate);
        return start <= end;
    }
};

export const numberUtils = {
    validateDecimals: (value, maxDecimals, { allowZero = false, allowNegative = false } = {}) => {
        if (!value && allowZero) return true;
        if (!value) return false;

        const numValue = parseFloat(String(value).replace(',', '.'));
        if (!allowZero && numValue === 0) return false;
        if (!allowNegative && numValue < 0) return false;

        const regex = new RegExp(`^-?\\d+(\\.\\d{3})*(,\\d{0,${maxDecimals}})*$`);
        return regex.test(value);
    },

    validatePercentage: (value, allowZero = false) => {
        if (!value && allowZero) return true;
        if (!value) return false;

        const numValue = parseFloat(String(value).replace(',', '.'));
        if (allowZero) {
            return numValue >= 0 && numValue <= 100;
        }
        return numValue > 0 && numValue <= 100;
    }
};

export const dataUtils = {
    compareDataSources: (source1, source2) => {
        if (!source1 || !source2) return false;
        return JSON.stringify(source1) !== JSON.stringify(source2);
    },

    sortStringsConsideringCulture: (value1, value2, lookup) => {
        if (lookup?.valueExpr === "key" && lookup.valueMap) {
            value1 = lookup.valueMap[value1] || value1;
            value2 = lookup.valueMap[value2] || value2;
        }

        if (!isNaN(value1) && !isNaN(value2)) {
            return Number(value1) - Number(value2);
        }

        if (!value1 && !value2) return 0;
        if (!value1) return -1;
        if (!value2) return 1;

        return String(value1).localeCompare(String(value2));
    }
};
